import { getTodoFolderById } from 'owa-todo-folders';
import { isFlaggedEmailFolder } from 'owa-todo-utils';
import { isTodoFolderList, isTodoMyDayList, TodoListId } from 'owa-todo-list-types';
import { assertNever } from 'owa-assert';

export function canCreateTaskInList(listId: TodoListId): boolean {
    if (isTodoMyDayList(listId)) {
        return true;
    } else if (isTodoFolderList(listId)) {
        if (!listId.Id) {
            // Users can always add in the default folder
            return true;
        }
        const todoFolder = getTodoFolderById(listId.Id);
        return todoFolder && !isFlaggedEmailFolder(todoFolder);
    }
    return assertNever(listId);
}
